module.exports = __webpack_public_path__ + "img/site_type_img_20.c352f933.png";